import { combineReducers } from "redux";
import PackagesReducer from "../reducers/Packages.reducer";
import CommonReducer from "../reducers/Common.reducer";
import SalonDetailsReducer from "../reducers/SalonDetails.reducer";
import MyBookingsReducer from "../reducers/MyBookings.reducer";
import SalonSideReducer from "../reducers/SalonSide.reducer";
import ExpensesReducer from "../reducers/Expenses.reducer";
import PromoReducer from "../reducers/Promo.reducer";

const reducers = combineReducers({
  PackagesReducer,
  CommonReducer,
  SalonDetailsReducer,
  MyBookingsReducer,
  SalonSideReducer,
  ExpensesReducer,
  PromoReducer,
});

export default reducers;
